module.exports = __webpack_public_path__ + "static/slide3-73078d58a201e48fc4991659162aee4b.png";